<template>
  <div>
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="container-xl">
      <div class="title-area">
        <div class="d-flex">
          <div class="pe-4">
            <div class="survey-type-badge btn-primary">
              <fa-icon icon="graduation-cap" class="survey-icon" />
            </div>
          </div>
          <h1 class="h2 d-flex align-items-center">
            {{ tutorial_heading }}
          </h1>
        </div>
      </div>
      <div class="row">
        <div class="col-12 me-2" v-html="tutorial_description" />
        <div class="col-12">
          <iframe
            :src="tutorial_link"
            width="640"
            height="360"
            frameborder="0"
            allow="autoplay;
            fullscreen"
            allowfullscreen
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import Navbar from "./Navbar.vue";
import Breadcrumb from "./Breadcrumb.vue";

const store = useStore();

const tutorial_id = ref(store.state.currenttutorial_id);
const tutorial_heading = ref(null);
const tutorial_description = ref(null);
const tutorial_link = ref(null);

const tutorial_get = () => {
  store
    .dispatch("tutorial_fetch", { tutorial_id: tutorial_id.value })
    .then((resp) => {
      tutorial_heading.value = resp.data.tutorial_heading;
      tutorial_description.value = resp.data.tutorial_description;
      tutorial_link.value = resp.data.tutorial_link;
    });
};

onMounted(() => {
  tutorial_get();
});
</script>

<style scoped>
.survey-type-badge {
  background-color: #007d8f !important;
}

.survey-icon,
.survey-type-badge .fa-icon {
  color: #ffffff !important;
  fill: #ffffff !important;
  opacity: 1 !important;
  width: 36px;
  height: 36px;
}
</style>
